import { useEffect, useState } from "react";
import api from "../utils/api/axiosInstance";
import { resolveProductImagePath } from "../utils/imageUtils";

const hasUsableImage = (product) => Boolean(resolveProductImagePath(product));

const mergeProduct = (base, fetched) => {
  if (!fetched) return base;
  return {
    ...fetched,
    matchScore: base?.matchScore ?? fetched.matchScore,
    rank: base?.rank ?? fetched.rank,
    matchExplanation: base?.matchExplanation ?? fetched.matchExplanation,
  };
};

export default function useEnrichedMatchProducts(products = []) {
  const [enrichedProducts, setEnrichedProducts] = useState(products);
  const productKey = products.map((p) => p._id).join(",");

  useEffect(() => {
    setEnrichedProducts(products);
  }, [productKey, products]);

  useEffect(() => {
    if (!products.length) return undefined;

    const needsFetch = products.some((product) => !hasUsableImage(product));
    if (!needsFetch) {
      setEnrichedProducts(products);
      return undefined;
    }

    let cancelled = false;

    Promise.all(
      products.map((product) =>
        hasUsableImage(product)
          ? Promise.resolve(product)
          : api
              .get(`/products/${product._id}`)
              .then((res) => mergeProduct(product, res.data))
              .catch(() => product),
      ),
    ).then((resolved) => {
      if (!cancelled) setEnrichedProducts(resolved);
    });

    return () => {
      cancelled = true;
    };
  }, [productKey, products]);

  return enrichedProducts;
}
